import { RegulatoryWellTypeBase } from './base/regulatory-well-type-base';

export class RegulatoryWellType extends RegulatoryWellTypeBase { }